import React, { useEffect, useState } from 'react';

export default function NCAAM() {
  const [predicciones, setPredicciones] = useState([]);

  useEffect(() => {
    fetch('/2025-04-01_top10.json')
      .then((res) => res.json())
      .then((data) => {
        const prediccionesNCAAM = data.filter((item) =>
          item.liga && item.liga.toLowerCase().includes('ncaam')
        );
        setPredicciones(prediccionesNCAAM);
      })
      .catch((error) => {
        console.error('Error al cargar las predicciones:', error);
      });
  }, []);

  return (
    <div className="p-4 text-white">
      <h2 className="text-2xl font-bold mb-4">Predicciones NCAAM (IA)</h2>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left border-b border-gray-600">
            <th>#</th>
            <th>Liga</th>
            <th>Predicción 1</th>
            <th>Predicción 2</th>
            <th>Confianza</th>
          </tr>
        </thead>
        <tbody>
          {predicciones.map((pred, index) => (
            <tr key={index} className="border-b border-gray-700 hover:bg-gray-800">
              <td>{index + 1}</td>
              <td>{pred.liga}</td>
              <td>{pred.prediccion1}</td>
              <td>{pred.prediccion2}</td>
              <td>{pred.confianza}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
